import React, {useContext, useEffect, useState} from 'react'
import {Modal, ModalBody} from 'reactstrap'
import strings from '../../../lang/strings'
import {Page_settings} from '../../../config/page_settings'
import {observer} from 'mobx-react'
import ConfirmButton from '../button/confirm_button'
import {formatNumber, string} from '../../../helper/common'
import {rootStore} from '../../../mobx/store'

const CouponRegisterModal = observer((props) => {
  const context = useContext(Page_settings)
  const {show, toggle} = props
  let [couponNum1, setCouponNum1] = useState('')
  let [couponNum2, setCouponNum2] = useState('')
  let [couponNum3, setCouponNum3] = useState('')
  let [couponResult, setCouponResult] = useState(strings.search_coupon)
  let [couponId, setCouponId] = useState(0)
  let [error, setError] = useState('')

  useEffect(() => {
    setError('')
  }, [couponNum1, couponNum2, couponNum3])

  const onConfirm = () => {
    if (couponId == 0) return
    context.post('pay/add_coupon', {cp_id: couponId},
      response => {
        let mb = rootStore.getMe
        mb.mb_point = response.mb_point
        rootStore.signIn(mb)
        setCouponResult(strings.search_coupon)
        setCouponId(0)
        setCouponNum1('')
        setCouponNum2('')
        setCouponNum3('')
        props.onConfirm()
      },
      true,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  const onSearch = () => {
    if (couponNum1.length !== 4 || couponNum2.length !== 4 || couponNum3.length !== 4) {
      setError(strings.coupon_code_error)
      return
    }
    context.post('pay/search_coupon', {code: couponNum1 + '-' + couponNum2 + '-' + couponNum3},
      response => {
        let mb = rootStore.getMe
        mb.mb_point = response.mb_point
        rootStore.signIn(mb)
        if (response.coupon) {
          const cp = response.coupon
          const lv_min_str = cp.cp_lv_min > 0 ? string.Format(strings.coupon_lv_min, formatNumber(cp.cp_lv_min)) : ''
          setCouponResult(string.Format(strings.search_coupon_success, cp.cp_name, cp.cp_expire.dateFormat('YYYY'), cp.cp_expire.dateFormat('MM'), cp.cp_expire.dateFormat('DD'), lv_min_str, formatNumber(cp.cp_price)))
          setCouponId(cp.cp_id)
        } else {
          setCouponResult(strings.search_coupon_not)
        }
      },
      false,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  return (
    <Modal isOpen={show} toggle={() => toggle()} className='modal-coupon-register modal-point-pay'>
      <ModalBody>
        <div className='modal-header-custom d-center position-relative'>
          <div className='fs-20 sm-fs-18 f-b'>{strings.coupon_register}</div>
          <div className='modal-close-btn d-center position-absolute' onClick={() => toggle()}>
            <img src={'/assets/image/close.png'} alt='' className='modal-close'/>
          </div>
        </div>
        <div className='modal-content-area fs-16 sm-fs-15 f-m'>
          <div className='fs-18 sm-fs-14 f-m'>{strings.enter_coupon_number}</div>
          <div className='search-area pv-20 ph-20 w-100 mt-20'>
            <div className='fs-18 sm-fs-14 f-m'>{strings.coupon_number}</div>
            <div className='d-flex w-100 mt-10'>
              <div className='flex-full input-num'>
                <input className='input-num-style text-center' maxLength={4} value={couponNum1} onChange={(e) => {setCouponNum1(e.target.value)}} />
              </div>
              <div className='mh-5'>-</div>
              <div className='flex-full input-num'>
                <input className='input-num-style text-center' maxLength={4} value={couponNum2} onChange={(e) => {setCouponNum2(e.target.value)}} />
              </div>
              <div className='mh-5'>-</div>
              <div className='flex-full input-num'>
                <input className='input-num-style text-center' maxLength={4} value={couponNum3} onChange={(e) => {setCouponNum3(e.target.value)}} />
              </div>
              <div className='btn-search pv-5 ph-30 ml-20 fs-12 sm-fs-10 cursor-point' onClick={onSearch}>{strings.search}</div>
            </div>
            <div className={'invalid-feedback ' + (error !== '' ? 'error' : '')}>{error}</div>
          </div>
          <div className='fs-14 sm-fs-12 f-m mt-30 space-break'>{couponResult}</div>
          <div className='d-center mt-60 sm-mt-20'>
            <ConfirmButton enabled={true} className={'bd-0 btn-primary fs-15 sm-fs-14 f-m d-center'} onClick={() => onConfirm()} text={strings.registering} />
            <ConfirmButton enabled={true} className={'btn-grey-border fs-15 sm-fs-14 f-m d-center ml-10'} onClick={toggle} text={strings.close} />
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
})

export default CouponRegisterModal
